import React, { useState } from "react";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import logo from "../../img/logo.png";

function Navbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    setSidebarOpen(false); // Close sidebar when a link is clicked
  };

  return (
    <div className="nav">
      <nav className="navbar navbar-expand-lg ">
        <div className="container">
          <Link className="navbar-brand" to="/" onClick={scrollToTop}>
            <img src={logo} alt="" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleSidebar}
          >
            {sidebarOpen ? (
              "Close"
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>
          <div
            className={`collapse navbar-collapse ${
              sidebarOpen ? "d-none" : ""
            }`}
            id="navbarNav"
          >
            <ul className="navbar-nav  me-auto">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  aria-current="page"
                  to="/"
                  onClick={scrollToTop}
                >
                  الصفحة الرئيسة
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services" onClick={scrollToTop}>
                  الخدمات
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about" onClick={scrollToTop}>
                  من نحن
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact" onClick={scrollToTop}>
                  تواصل معنا
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/login" onClick={scrollToTop}>
                  تسجيل الدخول{" "}
                </Link>
              </li>

              <li className="nav-item mx-5">
                <Link
                  className=" btn btn-danger"
                  to="/SendData"
                  onClick={scrollToTop}
                >
                  حجز شحنة
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="brek"></div>

      <div className={`sidebar ${sidebarOpen ? "active" : ""}`} id="sidebar">
        <button onClick={toggleSidebar} className="close-btn">
          <i className="fa-regular fa-circle-xmark"></i>
        </button>
        <ul>
          <li>
            <Link to="/" onClick={scrollToTop}>
              الصفحة الرئيسة
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={scrollToTop}>
              الخدمات
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={scrollToTop}>
              من نحن
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={scrollToTop}>
              تواصل معنا
            </Link>
          </li>
          <li>
            <Link to="/SendData" className="add" onClick={scrollToTop}>
              حجز خدمة توصيل
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;
